/* eslint-disable @next/next/no-img-element */
import React from "react";
import { useRecoilValue } from "recoil";
import { authAtom } from "@_recoil/_state";
import moment from "moment";
import { MdCalendarToday, MdForum, MdRemoveRedEye } from "react-icons/md";
import Image from "next/legacy/image";
import BookmarkAction from "@unisearch/common/ui_element/actions/bookmark";
import { isReadingListed } from "@unisearch/helpers";
import styles from "./page_info.module.scss";

const PageInfo = ({
  data,
  pageType,
  id,
  authorName,
  authorImage,
  ...props
}) => {
  const profileInfo = useRecoilValue(authAtom);

  return (
    <div className={styles.short_info}>
      {data && (
        <div className={`${styles.author} ${styles.info_item}`}>
          <div className={styles.icon}>
            <Image
              src={authorImage || "/favicon.jpg"}
              alt={authorName || "author"}
              width={30}
              height={30}
            />
          </div>
          <div className={styles.text}>
            <span className={styles.name}>{authorName}</span>
            <span className={styles.desc}>Author</span>
          </div>
        </div>
      )}

      {data && data?.publishDate && (
        <div className={`${styles.date} ${styles.info_item}`}>
          <div className={styles.icon}>
            <MdCalendarToday />
          </div>
          <div className={styles.text}>
            <span className={styles.name}>
              {moment(data.publishDate ?? new Date()).format("MMM DD, YYYY")}
            </span>
            <span className={styles.desc}>Date Published </span>
          </div>
        </div>
      )}

      {data && data?.totalView && (
        <div className={`${styles.view} ${styles.info_item}`}>
          <div className={styles.icon}>
            <MdRemoveRedEye />
          </div>
          <div className={styles.text}>
            <span className={styles.name}>{data.totalView ?? ""}</span>
            <span className={styles.desc}>Views</span>
          </div>
        </div>
      )}

      {data && data?.comments && (
        <div className={`${styles.comment} ${styles.info_item}`}>
          <div className={styles.icon}>
            <MdForum />
          </div>
          <div className={styles.text}>
            <span className={styles.name}>{data?.comments?.length || 0}</span>
            <span className={styles.desc}>Comments</span>
          </div>
        </div>
      )}

      <BookmarkAction
        referance={pageType}
        referanceId={id ? parseInt(id) : ""}
        is_bookmarked={isReadingListed(profileInfo, pageType, id)}
      />
    </div>
  );
};

export default PageInfo;
